import { Clipboard } from "@angular/cdk/clipboard";
import { CdkDrag, CdkDropList } from "@angular/cdk/drag-drop";
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { CommandService } from "@core/services/command.service";
import { SnackBarService } from '@core/services/snack-bar.service';
import { EliteFormPageModel, PageGroupItem } from "@features/elite-form/models/elite-form-common-data-models";
import { DesignItemModel, EliteFormOptionsConfig, EliteFormSubOptionsConfig } from '@features/elite-form/models/elite-form-design-item-model';
import { EliteFormDesignService } from "@features/elite-form/services/elite-form-design.service";
import { EliteFormFlowChartDataService } from "@features/elite-form/services/elite-form-flow-chart-data.service";
import { EliteFormManagerService } from "@features/elite-form/services/elite-form-manager.service";
import { EliteFormServiceFactory } from "@features/elite-form/services/elite-form-service-factory.service";
import { select, Store } from "@ngrx/store";
import { PlatformCommand } from "@shared/commands/command-base";
import { FieldDefinition } from "@shared/models/field-definition";
import { DialogService } from '@shared/services/dialog-service';
import { getCurrentPlatformLink, ParticleState } from "@shared/store/reducers/particle.reduer";
import { GridsterConfig } from "angular-gridster2";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'elite-form-field-designer-canvas',
  templateUrl: './elite-form-field-designer-canvas.component.html',
  styleUrls: ['./elite-form-field-designer-canvas.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EliteFormFieldDesignerCanvasComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() pageId: string;
  @Input() groupItems: PageGroupItem[];
  @Input() questions: any;
  @Input() flowchartSection: any;
  @Input() pageModel: EliteFormPageModel;

  isReady = false;
  allOptions: { [key: string]: GridsterConfig } = {}
  allGroupHeight: { [key: string]: number } = {};
  allPageQuestionGroupItem: { [key: string]: PageGroupItem } = {};

  dashboard: Array<DesignItemModel> = [];
  dashboardByGroup: _.Dictionary<DesignItemModel[]> = {};

  private unSubscribe$ = new Subject<void>();
  private eliteFormManagerService: EliteFormManagerService;
  pageQuestionGroupItems: PageGroupItem[];
  pageQuestionGroupItemsGroupedByParent: _.Dictionary<PageGroupItem[]> = {};
  private driveId: any;
  private qnrPathDirectoryEntryId: any;

  constructor(
    private commandService: CommandService,
    private router: Router,
    private eliteFormServiceFactory: EliteFormServiceFactory,
    private eliteFormFlowChartDataService: EliteFormFlowChartDataService,
    public eliteFormDesignService: EliteFormDesignService,
    public store: Store<ParticleState>,
    private snackBarService: SnackBarService,
    private clipboard: Clipboard,
    public dialogService: DialogService) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.enableGroupDragForId(this.eliteFormDesignService.activeCanvasId());
    }, 0);
  }


  ngOnInit() {
    if (!this.eliteFormDesignService.activeFlowchartId()) {
      this.eliteFormDesignService.setActiveFormInfo(this.pageModel.eliteFormId, this.pageModel.id, this.flowchartSection.flowchartId, this.flowchartSection.id, null, null);
    }
    if (!this.groupItems) {
      this.groupItems = this.pageModel.questions;
    }
    this.convertToFlatData(this.groupItems, this.pageModel.id);
    // this.groupHeight = EliteFormOptionsConfig.
    this.eliteFormManagerService = this.eliteFormServiceFactory.getEliteFormManagerService(this.pageModel.eliteFormId)
    this.eliteFormDesignService.getActiveCanvasId(this.pageModel.id);
    this.allOptions[this.pageModel.id] = EliteFormOptionsConfig;
    this.groupItems.forEach(item => {
      if (item.type === 'Group') this.allPageQuestionGroupItem[item.id] = item;
    });

    this.constructDesignView(this.pageQuestionGroupItems, this.getQuestion());
    // this.constructDesignView(this.group.items, this.getQuestion());
    this.modifyRootOptionConfig();
    this.eliteFormManagerService.fieldLayoutChanged$.pipe(takeUntil(this.unSubscribe$)).subscribe(event => {
      console.log(event['item']);
      setTimeout(() => {
        if (this.isReady) {
          this.saveDesignModel(event['item']);
        }
      }, 0);
    })
    this.isReady = true;
    this.store.pipe(select(getCurrentPlatformLink)).subscribe(platformLink => {
      if (platformLink) {
        this.driveId = platformLink.fieldValues['DriveId'];
        this.qnrPathDirectoryEntryId = platformLink.fieldValues['QnrPathDirectoryEntryId'];
      }
    });

  }


  convertToFlatData(items: PageGroupItem[], flowchartSectionId: string) {
    const flatData = [];
    items.forEach(item => {
      item.parentId = flowchartSectionId;
      flatData.push(item);
      if (item.type === 'Group') {
        const nestedItems = this.convertToFlatData(item.questions, item.metaData['ChildPageModelId']);
        flatData.push(...nestedItems);
      }
    });

    this.pageQuestionGroupItemsGroupedByParent = _.groupBy(flatData, 'parentId');
    this.pageQuestionGroupItems = flatData;

    return flatData;
  }

  modifyRootOptionConfig() {
    this.allGroupHeight[this.pageModel.id] = (6 + 1) * EliteFormOptionsConfig.fixedRowHeight + (6 - 1) * EliteFormOptionsConfig.margin;
    let maxRow = this.pageModel.minRows + 1;
    this.allOptions[this.pageModel.id].minRows = maxRow;
    this.allOptions[this.pageModel.id].maxRows = maxRow;
    this.allGroupHeight[this.pageModel.id] = (maxRow + 1) * EliteFormOptionsConfig.fixedRowHeight + (maxRow - 1) * EliteFormOptionsConfig.margin;

    const activeCanvasId = this.eliteFormDesignService.activeCanvasId();
    if (activeCanvasId) {
      this.enableGroupDragForId(activeCanvasId);
    }
  }

  getQuestion() {
    const filterQuestion = [];
    this.questions.forEach(question => {
      const filterQuestionRecursively = (items: PageGroupItem[]) => {
        items.forEach(item => {
          if (item.type === "Group") {
            filterQuestionRecursively(item.questions);
          }
          if (item.metaData['FieldKey'] && item.metaData['FieldKey'] === question.fieldKey) {
            filterQuestion.push(question);
          }
        });
      }

      filterQuestionRecursively(this.pageModel.questions);
    })
    return filterQuestion;
  }


  private constructDesignView(groupItems: PageGroupItem[], questions: any[]) {
    groupItems.sort((a, b) => a.row - b.row).forEach((item, i) => {
      let designModel = this.eliteFormManagerService.getEliteFormModel(item, questions.find(q => q.fieldKey === item.metaData['FieldKey']))

      if (item.type === 'Group') {
        this.allOptions[designModel.id] = { ...EliteFormSubOptionsConfig };
        var mr = item.rowSpan - 1;
        this.allOptions[designModel.id].maxRows = mr;
        this.allOptions[designModel.id].minRows = mr;
        this.allGroupHeight[designModel.id] = (mr + 1) * EliteFormOptionsConfig.fixedRowHeight + (mr - 1) * EliteFormOptionsConfig.margin;
      }

      this.dashboard.push(designModel);
    });

    setTimeout(() => {
      this.dashboardByGroup = _.groupBy(this.dashboard, 'parentId');
    }, 100);
  }

  selectGroup(designItemModel: DesignItemModel) {
    this.eliteFormDesignService.setActiveCanvasId(designItemModel.id);
    if (designItemModel.metaData['ChildFlowchartId'] && designItemModel.metaData['ChildFormId']) {
      this.eliteFormDesignService.setActiveFormInfo(
        designItemModel.metaData['ChildFormId'],
        designItemModel.metaData['ChildPageModelId'],
        designItemModel.metaData['ChildFlowchartId'],
        designItemModel.metaData['ChildFlowchartSectionId'],
        designItemModel.flowChartSectionId,
        designItemModel.pageGroupItemId,
      );
    }

    this.enableGroupDragForId(designItemModel.id);
  }

  selectRootGroup(groupId: string) {
    this.eliteFormDesignService.setActiveCanvasId(groupId);
    this.eliteFormDesignService.setActiveFormInfo(
      this.pageModel.eliteFormId,
      this.pageModel.id,
      this.flowchartSection.flowchartId,
      this.flowchartSection.id, null, null
    );
    this.enableGroupDragForId(groupId);
  }

  private enableGroupDragForId(id: string) {
    this.allOptions = {
      ...this.allOptions,
      [id]: {
        ...(this.allOptions[id] || {}),
        draggable: { enabled: true },
        resizable: { enabled: true }
      }
    };

    for (const key in this.allOptions) {
      if (this.allOptions.hasOwnProperty(key) && key !== id) {
        this.allOptions[key] = {
          ...this.allOptions[key],
          draggable: { enabled: false },
          resizable: { enabled: false }
        };
      }
    }

    setTimeout(() => {
      for (const key in this.allOptions) {
        if (this.allOptions.hasOwnProperty(key) && this.allOptions[key]?.api?.optionsChanged) {
          this.allOptions[key].api.optionsChanged();
        }
      }
    }, 1000)

  }

  removeItem(item) {
    this.dashboard.splice(this.dashboard.indexOf(item), 1);
  }

  drop(event: any) {
    this.addExternalField(event.item.data.dataItem);
  }

  private saveDesignModel(item: DesignItemModel) {
    const changedItems = [];

    changedItems.push({
      QuestionFieldKey: item.fieldKey,
      Row: item.y,
      RowSpan: item.rows,
      Column: item.x,
      ColumnSpan: item.cols
    });

    var mr = item.rows - 1;
    this.allGroupHeight[item.id] = (mr + 1) * EliteFormOptionsConfig.fixedRowHeight + (mr - 1) * EliteFormOptionsConfig.margin;

    for (const key in this.allOptions) {
      if (this.allOptions.hasOwnProperty(key) && this.allOptions[key]?.api) {
        this.allOptions[key].api.optionsChanged();
        this.allOptions[key].api.resize();
      }
    }

    this.eliteFormFlowChartDataService.updateQuestionPosition(this.eliteFormDesignService.activePageId(), '', changedItems);
  }

  addExternalField(fieldDefinition: FieldDefinition) {
    const fd = JSON.parse(JSON.stringify(fieldDefinition));
    if(fd.id==="Add_page"){
      this.eliteFormFlowChartDataService.addPage(this.pageModel.eliteFormId);
      return;
    }

    fd['key'] = Guid.create().toString();

    let y: number
    if (this.dashboardByGroup[this.eliteFormDesignService.activeCanvasId()]) {
      y = this.dashboardByGroup[this.eliteFormDesignService.activeCanvasId()].length === 0 ? 0 : Math.max(...this.dashboard.map(o => o.y)) + 1;
    } else { y = 0 }

    const x = 0;
    const rows = 1, cols = 12;
    const extraParams = {
      Row: y,
      RowSpan: fieldDefinition.dataType === 'Group' ? 2 : 1,
      Column: x,
      ColumnSpan: cols,
      EliteFormId: this.eliteFormDesignService.activeFormId(),
      EliteFormPageId: this.eliteFormDesignService.activePageId(),
      // EliteFromGroupId: this.group.id,
      GroupQuestionId: this.eliteFormDesignService.groupQuestionId(),
      ParentFlowSectionId: this.eliteFormDesignService.parentFlowSectionId(),
      ActiveGroupId: this.eliteFormDesignService.activeCanvasId(),
      DriveId: this.driveId,
      qnrPathDirectoryEntryId: this.qnrPathDirectoryEntryId
    };

    const canvasId = this.eliteFormDesignService.activeCanvasId();

    if (canvasId && this.allOptions[canvasId]?.api) {
      const nextPossiblePosition = this.allOptions[canvasId].api.getFirstPossiblePosition({
        x: x,
        y: y,
        cols: cols,
        rows: rows,
      })

      extraParams.Row = nextPossiblePosition.y;
    }
    if (fieldDefinition.fieldValues['FieldKey']) {
      extraParams['FieldKey'] = fieldDefinition.fieldValues['FieldKey'];
    }

    this.isReady = false;
    this.eliteFormFlowChartDataService.addOrUpdateFieldDefinitionInFlowChartCommandExecute(fd, 'Field', 'ADD', this.eliteFormDesignService.activeFlowchartSectionId(),
      this.eliteFormDesignService.activeFlowchartId(), false, extraParams)
      .then(response => {
        fd.header = response.fieldValues['FieldTitle'];
        this.isReady = false;

        this.modifyRootOptionConfig();

        if (response.fieldValues['RedirectCommand']) {
          this.executeCommandToApi(response.fieldValues['RedirectCommand'])
          return;
        }

        this.allOptions = JSON.parse(JSON.stringify(this.allOptions));

        console.log(response);
        this.eliteFormFlowChartDataService.refreshPages();
      });
  }

  canSort() {
    return (ind: number, drag: CdkDrag, drop: CdkDropList) => {
      return false;
    };
  }

  deleteField(designModel: DesignItemModel) {
    this.eliteFormFlowChartDataService.deleteField(designModel.flowChartId, designModel.flowChartSectionId, designModel.id, designModel.fieldKey, this.pageModel.id, '');
  }

  editField(designModel: DesignItemModel) {
    var questions = this.getQuestion();
    const fieldDefinition = questions.find(item => item.id === designModel.id);

    const extraParams = {
      'FieldKey': fieldDefinition.fieldKey,
      'FlowchartId': designModel.flowChartId,
      'FlowchartSectionId': designModel.flowChartSectionId,
    };
    // tslint:disable-next-line:max-line-length
    this.eliteFormFlowChartDataService.addOrUpdateFieldDefinitionInFlowChartCommandExecute(fieldDefinition, 'Field', 'UPDATE', designModel.flowChartSectionId, designModel.flowChartId, false, extraParams)
      .then(response => {
        this.eliteFormFlowChartDataService.refreshPages();
      });
  }

  moveQuestionBetweenGroup(item: DesignItemModel) {
    this.eliteFormFlowChartDataService.moveQuestionBetweenPages(
      {
        eliteFormId: item.parentId,
        flowChartSectionId: item.flowChartSectionId,
        pageGroupItemId: item.pageGroupItemId,
        sourceRootPageId: this.pageModel.id,
      }
    );
  }

  private executeCommandToApi(command: PlatformCommand) {
    this.commandService.executePlatformCommand(command).pipe(takeUntil(this.unSubscribe$)).subscribe(commandResponse => {
      if (commandResponse.fieldValues['RedirectUrl']) {
        if (commandResponse.fieldValues['RedirectUrl']) {
          const redirectUrl = commandResponse.fieldValues['RedirectUrl'];
          if (redirectUrl !== this.router.url) {
            this.router.navigateByUrl(redirectUrl);
            return;
          }
        }
      }
    });
  }

  copyValue(designModel: DesignItemModel, event: any) {
    this.clipboard.copy(designModel.fieldKey);
    this.snackBarService.showInformation('Field Key Copied for ' + designModel.title);
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this.eliteFormServiceFactory.destroyService(this.pageModel.eliteFormId);
  }
}
